import React from 'react';
import Section from '../ui/Section';
import { Target, Users, TrendingUp, Shield } from 'lucide-react';

const Mission: React.FC = () => {
  const values = [
    {
      icon: <Target className="text-primary" size={24} />,
      title: 'Strategic Focus',
      description: 'We help teams identify the most impactful AI opportunities and avoid common pitfalls.'
    },
    {
      icon: <Users className="text-primary\" size={24} />,
      title: 'Human-Centered',
      description: 'We believe AI products must be designed around human needs, expectations, and experiences.'
    },
    {
      icon: <TrendingUp className="text-primary" size={24} />,
      title: 'Measurable Impact',
      description: 'We define success through quantifiable business outcomes, not just technical achievements.'
    },
    {
      icon: <Shield className="text-primary\" size={24} />,
      title: 'Ethical Foundation',
      description: 'We help teams build AI products that are responsible, transparent, and aligned with human values.'
    }
  ];
  
  return (
    <Section className="bg-neutral-900/50">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
        <div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Our Mission</h2>
          <p className="text-lg text-neutral-300 mb-6 text-justify">
            At Product Leap AI, we help teams build AI products that deliver real value. We bridge the gap between technical possibilities and market realities.
          </p>
          <p className="text-lg text-neutral-300 mb-6 text-justify">
            We believe that the most successful AI products are those that solve real problems for real people. Our mission is to help businesses create AI solutions that improve lives, enhance organizations, and drive business growth.
          </p>
          <p className="text-lg text-neutral-300 text-justify">
            With decades of combined experience in both product management and artificial intelligence, we guide teams through the unique challenges of building and scaling AI-driven products that succeed in the market.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {values.map((value, index) => (
            <div 
              key={index} 
              className="bg-neutral-800/50 backdrop-blur-sm rounded-xl border border-neutral-700 p-5 hover:border-primary/50 transition-colors"
            >
              <div className="flex items-center space-x-3 mb-3">
                <div className="h-10 w-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  {value.icon}
                </div>
                <h3 className="text-lg font-semibold">{value.title}</h3>
              </div>
              <p className="text-neutral-300 leading-snug">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default Mission;